import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog.modifier';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SharedFile } from '../SharedFiles.types';
import { IFileItem } from '../../../types/api/FileItem';
import { LoadingSpinnerContainer } from '../../../components/atoms/LoadingSpinner';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { SharedFilesAccordion } from './SharedFilesAccordion';
import { sendLiveRegionMessage } from '../../../components/atoms/LiveRegionGlobal/LiveRegionGlobal';
import { Keyword } from '../../../_lib/components/Keywords/partials/Keyword';
import { ICategory } from '../../../types/ICategory';

type SharedFilesInformation = {
  closeModal: () => void;
  file: SharedFile;
};

export type VersionedSharedFileInfo = {
  fileInfo: IFileItem;
  version: number;
  archiveDate?: string;
  author?: string;
  changeComment?: string;
  contentDate?: string;
  description?: string;
  keywords?: Keyword[];
  categories?: ICategory[];
};

/**
 * Detail Information about a file.
 */
export function SharedFilesInformation({ closeModal, file }: SharedFilesInformation) {
  const { t } = useSonTranslation('SharedFiles');
  const [versionInfo, setVersionInfo] = useState<VersionedSharedFileInfo[] | 'error' | 'loading'>('loading');

  useEffect(() => {
    sendLiveRegionMessage(t('phrases:contentIsLoading'));
    axios
      .get<VersionedSharedFileInfo[]>(file.infoUrl)
      .then(response => setVersionInfo(response.data))
      .catch(() => setVersionInfo('error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only rerender on infourl change
  }, [file.infoUrl]);

  function getVersionInfo() {
    switch (versionInfo) {
      case 'loading':
        return <LoadingSpinnerContainer modifier="overlay" />;
      case 'error':
        return <StatusInfoError />;
      default:
        return <SharedFilesAccordion versionInfo={versionInfo} />;
    }
  }

  return (
    <ModalDialog
      modifier={ModalDialogModifier.WIDE}
      closeModal={closeModal}
      headline={t('infoModal.headline')}
      initialFocusIndex={1}
    >
      <div className="shared-files__info">{getVersionInfo()}</div>
    </ModalDialog>
  );
}
